<template>
  <div>
    <h1>{{ localization['Change password'][ctx.language] }}</h1>
    <v-form
      v-if="showForm"
      ref="form"
      v-model="validForm"
      @submit.prevent>
      <v-text-field
        id="usernameOrEmail"
        v-model="email"
        :rules="[rules.required]"
        :label="localization['Email address'][ctx.language]"
      />
      <v-text-field
        v-show="false"
        id="usernameOrEmail"
        v-model="ctx.user.username"
        :rules="[rules.required]"
        :label="localization['Username or email'][ctx.language]"
      />
      <Password
        v-model="oldPassword"
        :confirmation="false"
        :label="localization['Password'][ctx.language]"
        :id="'oldPassword'"
        :language="ctx.language"
        disablePasswordValidation
      />
      <Password
        v-model="newPassword"
        :confirmation="true"
        :label="localization['New password'][ctx.language]"
        :id="'newPassword'"
        :language="ctx.language"
      />
      <v-btn
        id="submitButton"
        :disabled="!validForm || submitting"
        @click="submit"
      >{{ localization['REQUEST PASSWORD CHANGE'][ctx.language] }}</v-btn
      >
    </v-form>

    <div v-if="ctx.isAccessRequest()">
      <v-divider class="mt-3 mb-2" />
      <router-link
        :to="{ name: 'Authorization' }"
      ><h3>{{ localization['Go to Sign in'][ctx.language] }}</h3></router-link
      >
    </div>

    <Alerts
      :successMsg="success"
      :errorMsg="error" />
  </div>
</template>

<script>
import Password from './bits/Password';
import Alerts from './bits/Alerts';
import controllerFactory from '../controller/controller.js';
import Context from '../../context.js';
import localization from '../../translationDict.json';

export default {
  components: {
    Password,
    Alerts,
  },
  data: () => ({
    showForm: true,
    oldPassword: '',
    newPassword: '',
    error: '',
    success: '',
    submitting: false,
    ctx: {},
    controllerFactory: null,
    validForm: false,
    email: '',
  }),
  computed: {
    rules: function () {
      return {required: value => !!value || this.localization['This field is required.'][this.language]};
    },
  },
  watch: {
    email (newEmail) {
      this.ctx.user.username = newEmail;
    },
  },
  async created () {
    this.localization = JSON.parse(JSON.stringify(localization));
    this.ctx = new Context(this.$route.query);
    await this.ctx.init();
    this.controllerFactory = controllerFactory(this.ctx);
  },
  methods: {
    submit () {
      this.ctx.user.username = this.ctx.user.username.trim();
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.controllerFactory.login(this.oldPassword)
          .then(() => this.controllerFactory
            .changePassword(this.oldPassword, this.newPassword))
          .then(() => {
            this.showForm = false;
            this.success = this.localization['Password Changed'][this.ctx.language];
          })
          .catch(this.showError)
          .finally(() => {
            this.submitting = false;
          });
      }
    },
    showError (error) {
      this.error = error.msg;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/ChangePassword.vue